import React from "react";
import Layout from "@/components/layout/Layout";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export default function OwnerRegisterPage() {
  return (
    <Layout>
      <div className="container mx-auto py-8">
        <div className="max-w-md mx-auto">
          <Card>
            <CardHeader>
              <CardTitle>Owner Registration</CardTitle>
              <CardDescription>
                Register as a nursing home owner
              </CardDescription>
            </CardHeader>
            <CardContent>
              <p className="text-muted-foreground">
                Owner registration functionality coming soon.
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </Layout>
  );
}